import React from "react";
export const SocketContext = React.createContext(null);
export const SetSocketContext  = React.createContext(() => {});


export default SocketContext;